import { helpers } 		from '../helpers.js';

var cacheLogic = {
	selectors: { },

	init: function () {
		var self = this;

        self.loadAll();
	},

	loadAll: function() {
		var self = this;

		jQuery( '[data-cache]' ).each(function(){
			let $element 	= jQuery( this );
			let cacheKey 	= $element.attr( 'data-cache' );
			var storageItem = helpers.sessionStorage( cacheKey );

			// in storage
			if( storageItem ) {
				$element.html( storageItem );
			} else {
				// needs loading
				self.ajaxCall( $element, cacheKey, {
					action: 'cacheLogic',
					cacheKey: cacheKey,
					key: 'd02a3b93a48c62e67c39172c805e7f3c'
				});
			}
		});
	},

	suceesLoad: function( $element, cacheKey, cachedData ) {
		var self = this;

		helpers.sessionStorage( cacheKey, cachedData );
		$element.html( cachedData );

		// Check promotion visibility after loading
		if ( cacheKey.indexOf( 'promotion' ) !== -1 ) {
			self.checkPromotionVisibility();
		}
	},

	checkPromotionVisibility: function() {
		var self = this;
		jQuery( '.js-promotion-item' ).each( function() {
			var $item = jQuery( this );
			var from = $item.data( 'from' );  // Y-m-d format
			var to = $item.data( 'to' );      // Y-m-d format

			if ( ! from && ! to ) {
				return; // No date restrictions - always show
			}

			var now = new Date();
			now.setHours( 0, 0, 0, 0 ); // Compare dates only, not time
			var isVisible = true;

			if ( from ) {
				var fromDate = self.parseDate( from );
				if ( fromDate && now < fromDate ) {
					isVisible = false;
				}
			}

			if ( to ) {
				var toDate = self.parseDate( to );
				if ( toDate && now > toDate ) {
					isVisible = false;
				}
			}

			if ( ! isVisible ) {
				$item.remove();
			}
		});
	},

	parseDate: function( dateStr ) {
		// Format: Y-m-d (e.g., "2026-01-28")
		if ( ! dateStr ) return null;
		var parts = dateStr.split( '-' );
		if ( parts.length !== 3 ) return null;
		return new Date( parseInt( parts[0] ), parseInt( parts[1] ) - 1, parseInt( parts[2] ) );
	},

	ajaxCall: function( $element, cacheKey, data, type = 'POST' ) {
		var self = this;

		jQuery.ajax({
			type: type,
			url: sikmoVars.ajax_url,
			data: data,
            success: function( response ){
				if( ! response ) {
					console.error( 'Totální error' );
					return '';
				}

				if( ! response.success ) {
					console.error( response.data.message );
					return '';
				}

				if( response.success ) {
					return self.suceesLoad( $element, cacheKey, response.data.content );
				}
			}
		});
	}

	// GET  helpers.sessionStorage( key );
	// SAVE helpers.sessionStorage( key, value ); 60min default
	// SAVE helpers.sessionStorage( key, 120 ); 120min custom
};

export { cacheLogic };
